var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Row } from "../index";
import { useState, useEffect } from "react";
import Column from "./Column";
import { DragDropContext } from "react-beautiful-dnd";
function convertElementsData(columns) {
    var cols = {};
    for (var _i = 0, _a = Object.entries(columns); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], elements = _b[1];
        cols[key] = {
            id: key,
            list: elements
        };
    }
    return cols;
}
function DnD(props) {
    var elements = props.elements, setContents = props.setContents, dealWithContents = props.dealWithContents;
    var _a = useState(convertElementsData(elements)), columns = _a[0], setColumns = _a[1];
    var editMode = true;
    if (props.editMode === false)
        editMode = false;
    var onDragEnd = function (_a) {
        var source = _a.source, destination = _a.destination;
        // make sure we have a valid destination
        if (destination === undefined || destination === null)
            return null;
        // make sure we're actually moving the item
        if (source.droppableId === destination.droppableId &&
            destination.index === source.index) {
            return null;
        }
        // set start and end variables
        var start = columns[source.droppableId];
        var end = columns[destination.droppableId];
        // if start is the same as end, we're in the same column
        if (start === end) {
            // move the item within the list
            // start by making a new list without the dragged item
            var newList = start.list.filter(function (_, idx) { return idx !== source.index; });
            // then insert the item at the right location
            newList.splice(destination.index, 0, start.list[source.index]);
            // then create a new copy of the column object
            var newCol_1 = {
                id: start.id,
                list: newList
            };
            // update the state
            setColumns(function (state) {
                var _a;
                return (__assign(__assign({}, state), (_a = {}, _a[newCol_1.id] = newCol_1, _a)));
            });
        }
        else {
            // ff start is different from end, we need to update multiple columns
            // filter the start list like before
            var newStartList = start.list.filter(function (_, idx) { return idx !== source.index; });
            // create a new start column
            var newStartCol_1 = {
                id: start.id,
                list: newStartList
            };
            // stop on drop with custom function
            if (dealWithContents !== undefined) {
                // false = don't allow drop
                if (!dealWithContents(newStartCol_1))
                    return null;
            }
            // make a new end list array
            var newEndList = end.list;
            // insert the item into the end list
            newEndList.splice(destination.index, 0, start.list[source.index]);
            // create a new end column
            var newEndCol_1 = {
                id: end.id,
                list: newEndList
            };
            // update the state
            setColumns(function (state) {
                var _a;
                return (__assign(__assign({}, state), (_a = {}, _a[newStartCol_1.id] = newStartCol_1, _a[newEndCol_1.id] = newEndCol_1, _a)));
            });
        }
        return null;
    };
    useEffect(function () {
        // accessing the data outside of the component
        if (setContents !== undefined) {
            setContents(columns);
        }
    }, [columns]);
    return (_jsx(DragDropContext, __assign({ onDragEnd: onDragEnd }, { children: _jsx(Row, __assign({ style: {
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: 0,
                paddingRight: 0,
            } }, { children: Object.values(columns).map(function (col) { return (_jsx(Column, { col: col, editMode: editMode }, col.id)); }) })) })));
}
export default DnD;
